import React, { Component } from 'react';
import KpiCard from './shared/KpiCard';
import { formatNum } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

class AdminPayouts extends Component {
  constructor(props) {
    super(props);
    this.state = { payouts: [], loading: true };
    this.fetchPayouts = this.fetchPayouts.bind(this);
  }

  componentDidMount() {
    this.fetchPayouts();
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshKey !== prevProps.refreshKey) {
      this.fetchPayouts();
    }
  }

  fetchPayouts() {
    var self = this;
    self.setState({ loading: true });
    var params = new URLSearchParams();
    params.append('status', 'held');
    params.append('limit', 100);
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/transactions?' + params.toString())
      .then(function(data) { self.setState({ payouts: data.transactions, loading: false }); })
      .catch(function(err) { console.log('Failed to fetch payouts:', err); self.setState({ loading: false }); });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var payouts = this.state.payouts;

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <div className="tw-text-center">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
            <span className="tw-text-sm tw-text-[#999]">Loading...</span>
          </div>
        </div>
      );
    }

    var pending = [];
    var awaitingShipment = [];
    var now = Date.now();

    payouts.forEach(function(tx) {
      if (tx.shippedAt && tx.payoutScheduledAt) pending.push(tx);
      else awaitingShipment.push(tx);
    });
    pending.sort(function(a, b) { return new Date(a.payoutScheduledAt) - new Date(b.payoutScheduledAt); });

    var totalHeld = payouts.reduce(function(s, t) { return s + (t.sellerPayout || 0); }, 0);
    var pendingTotal = pending.reduce(function(s, t) { return s + (t.sellerPayout || 0); }, 0);
    var awaitingTotal = awaitingShipment.reduce(function(s, t) { return s + (t.sellerPayout || 0); }, 0);

    return (
      <div>
        {/* Summary Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-4 tw-mb-6">
          <KpiCard icon="fa-lock" label="Total Held" value={'$' + formatNum(totalHeld)} change={payouts.length + ' orders'} color="#3B82F6" />
          <KpiCard icon="fa-clock-o" label="Pending Release" value={'$' + formatNum(pendingTotal)} change={pending.length + ' shipped'} color="#D4A843" />
          <KpiCard icon="fa-truck" label="Awaiting Shipment" value={awaitingShipment.length + ' orders'} change={'$' + formatNum(awaitingTotal)} color="#6B7280" />
        </div>

        {/* Pending Release */}
        {pending.length > 0 && (
          <div className="tw-rounded-xl tw-overflow-hidden tw-mb-6" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-px-5 tw-py-3" style={{ borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              <h3 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Pending Auto-Release</h3>
            </div>
            <div className="tw-overflow-x-auto">
              <table className="tw-w-full tw-text-sm" style={{ minWidth: '560px' }}>
                <thead>
                  <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa' }}>
                    <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Item</th>
                    <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden sm:tw-table-cell">Seller</th>
                    <th className="tw-px-4 tw-py-2.5 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Payout</th>
                    <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Countdown</th>
                    <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pending.map(function(tx) {
                    var releaseDate = new Date(tx.payoutScheduledAt);
                    var daysLeft = Math.max(0, Math.ceil((releaseDate - now) / (1000 * 60 * 60 * 24)));
                    return (
                      <tr key={tx._id} className="tw-border-t tw-border-[#f0f0f0] dark:tw-border-[#222]">
                        <td className="tw-px-4 tw-py-3 tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-truncate tw-max-w-xs">{tx.post ? tx.post.title : 'Deleted'}</td>
                        <td className="tw-px-4 tw-py-3 tw-text-[#666] dark:tw-text-[#aaa] tw-hidden sm:tw-table-cell">{tx.seller ? tx.seller.userName : 'Unknown'}</td>
                        <td className="tw-px-4 tw-py-3 tw-text-right tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white">${(tx.sellerPayout || 0).toFixed(2)}</td>
                        <td className="tw-px-4 tw-py-3 tw-text-center">
                          {daysLeft > 0 ? (
                            <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-medium" style={{ color: '#D4A843' }}>
                              <i className="fa fa-clock-o" />{daysLeft}d
                            </span>
                          ) : (
                            <span className="tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-full" style={{ backgroundColor: '#ECFDF5', color: '#047857' }}>Ready</span>
                          )}
                        </td>
                        <td className="tw-px-4 tw-py-3 tw-text-center">
                          <button
                            className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-white tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                            style={{ backgroundColor: '#10B981' }}
                            onClick={function() { self.props.onConfirm({ type: 'release', txId: tx._id, title: tx.post ? tx.post.title : 'this order' }); }}
                          >
                            Release
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Awaiting Shipment */}
        {awaitingShipment.length > 0 && (
          <div className="tw-rounded-xl tw-p-5" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <h3 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-3">Awaiting Shipment ({awaitingShipment.length})</h3>
            <div className="tw-space-y-2">
              {awaitingShipment.slice(0, 10).map(function(tx) {
                return (
                  <div key={tx._id} className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] last:tw-border-0">
                    <span className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-truncate tw-max-w-xs">{tx.post ? tx.post.title : 'Deleted'}</span>
                    <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-flex-shrink-0">${(tx.sellerPayout || 0).toFixed(2)}</span>
                  </div>
                );
              })}
              {awaitingShipment.length > 10 && <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-2">...and {awaitingShipment.length - 10} more</p>}
            </div>
          </div>
        )}

        {payouts.length === 0 && (
          <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#ECFDF5' }}>
              <i className="fa fa-check tw-text-2xl" style={{ color: '#10B981' }} />
            </div>
            <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">No Held Funds</h3>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-1">All payouts have been released</p>
          </div>
        )}
      </div>
    );
  }
}

export default AdminPayouts;
